<template>
	<div :class='myimg'>
		<top-image class="norme-img" :myimg="myimg"></top-image>
		<!-- <smallSearch></smallSearch> -->
		<top-little-image class="little-img" :myLittleimg="myLittleimg"></top-little-image>
		<div class="conten-word">
			<span :class="index" v-for="(item,index) in cnword">{{item}}</span>
			<div class="chapter2">
				<span :class="index" v-for="(item, index) in cnword1">{{item}}</span>
			</div>
			<div class="chapter3">
				<div class="mix-content" v-for="(item, index) in cnword2">
					<img :src="'static/image/about-img/' + index + '.jpg'" alt="图片" class="inner-img">
					<span class="inner-shuoMing" v-for="value,key,ind in item">{{value}}</span>
				</div>
			</div>
			<div class="chapter4">
				<span :class="index" v-for="(item, index) in cnword3">{{item}}</span>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
import TopImage from 'components/top-image/top-image'
import TopLittleImage from 'components/top-image/top-little-image'
// import smallSearch from 'common/small-search/small-search'

export default {
	data() {
		return {
			myimg: 'about-us',
			myLittleimg: 'about-us-small'
		}
	},
	created() {
	},
	methods: {
	},
	computed: {
		cnword() {
			return this.$t('chapter3[0]')
		},
		cnword1() {
			return this.$t('chapter4[0]')
		},
		cnword2() {
			return this.$t('chapter5')
		},
		cnword3() {
			return this.$t('chapter6[0]')
		}
	},
	components:{
		TopImage,
		TopLittleImage
	}
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.about-us
		position: relative
		color: $color-theme
		.norme-img
			display: block
			@media screen and (max-width:600px)
				display: none
		.small-search
			position: absolute
			background: $color-theme
			height: 35px
			width: 100%
			@media screen and (max-width:600px)
				display: none
		.little-img
			display: none
			@media screen and (max-width:600px)
				display: block
		.conten-word
			margin: 60px auto
			width: 70%
			@media screen and (max-width:550px)
				width: 80%
			.title, .title1, .entitle, .entitle1
				font-size: $font-web-medium
				display: block
				text-align: center
				line-height: 30px
				@media screen and (max-width:550px)
					font-size: $font-web-medium-s
			.entitle, .entitle1
				color: $color-text-g
				line-height: 22px
				font-size: $font-web-medium-s
				@media screen and (max-width:550px)
					font-size: $font-web-small
			.inner1, .inner2, .inner3, .inner4
				display: block
				margin: 20px 0
				font-size: $font-web-small
				line-height: 23px
				color: $color-text-g
		.chapter2
			margin: 80px 0 50px
		.chapter3
			display: flex
			flex-wrap: wrap
			justify-content: center
			.mix-content
				flex: 1
				min-width: 30%
				max-width: 30%
				margin: 10px 
				@media screen and (max-width:550px)
					min-width: 44%
					max-width: 44%
					margin: 5px 
				.inner-img, .inner-shuoMing
					display: block
					width: 100%
				span:nth-child(2)
					font-size: $font-web-small-l
					text-align: center
					position: relative
					width: 90%
					margin: -10px auto 10px
					color: $color-text
					background: $color-theme
					@media screen and (max-width:550px)
						font-size: $font-web-small-s
		.chapter4
			margin: 80px 0 100px 0
			.inner, .inner1
				color: $color-text-g
				font-size: $font-web-small
				text-align: center
				padding: 10px 0
				margin: 0
				@media screen and (max-width:550px)
					text-align: left
			.inner
				margin-top: 50px
		.chapter4>span
			display: block

</style>



// WEBPACK FOOTER //
// src/components/about-us/about-us.vue